import { render, staticRenderFns } from "./SaleTable.vue?vue&type=template&id=b9fa4b10&scoped=true"
import script from "./SaleTable.vue?vue&type=script&lang=js"
export * from "./SaleTable.vue?vue&type=script&lang=js"
import style0 from "./SaleTable.vue?vue&type=style&index=0&id=b9fa4b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9fa4b10",
  null
  
)

export default component.exports